import React, { FC, useContext, useMemo } from 'react';

import styled from 'styled-components';

// constants
import aampeTheme from '../../../../constants/aampeTheme';

// context
import { EditorContext } from '../../../../context/EditorContext';

// models
import { SMSPreviewModel } from '../../../../models/editor.model';
import { PreviewComponentProps } from '../../../../models/formula.model';

// components
import Phone from '../shared/Phone';

const SmsMain: FC<
    React.PropsWithChildren<PreviewComponentProps<SMSPreviewModel>>
> = ({ randomSample, formulaHasVariant }) => {
    const { editorDetails } = useContext(EditorContext);

    const hasText = useMemo(() => {
        const previews = editorDetails.previews?.[0] as any;
        return previews?.content.message;
    }, [editorDetails.previews]);

    return (
        <Phone hasText={hasText} formulaHasVariant={formulaHasVariant}>
            {randomSample.map((preview, i) => (
                <Message key={i + preview.id}>
                    {Object.values(preview.content).join()}
                </Message>
            ))}
        </Phone>
    );
};

export default SmsMain;

const Message = styled.div({
    backgroundColor: aampeTheme.colors.gray50,
    padding: aampeTheme.spacing(2, 1),
    borderRadius: aampeTheme.borderRadius.default,
    display: 'flex',
    color: aampeTheme.colors.gray800,
    alignItems: 'center',
    width: '82%',
    lineHeight: '24px',
    fontSize: '16px',
    whiteSpace: 'pre-wrap',
});
